import { useState } from 'react';
import { Shield } from 'lucide-react';
import { useTenant, DEFAULT_FALLBACK_TENANT } from '../../context/TenantContext.jsx';
import { cn } from '../../lib/utils.js';

export function TenantLogo({ className, showSlogan = false, tenant: propTenant }) {
  let contextTenant = null;
  try {
    const ctx = useTenant();
    contextTenant = ctx?.tenant;
  } catch {
    contextTenant = null;
  }

  const tenant = propTenant || contextTenant || DEFAULT_FALLBACK_TENANT;
  const [imageError, setImageError] = useState(false);

  const hasCustomLogo = Boolean(tenant?.logoUrl || tenant?.logo_url) && !imageError;
  const logoUrl = tenant?.logoUrl || tenant?.logo_url;
  const brandName = tenant?.name || 'ASL Partner';
  const shortName = tenant?.settings?.branding?.shortName || brandName;
  const slogan = tenant?.settings?.branding?.slogan || 'Fachbetrieb für Sicherheitstechnik';

  if (hasCustomLogo && logoUrl) {
    return (
      <div className={cn('flex min-w-0 items-center gap-3', className)}>
        <img
          src={logoUrl}
          alt={`${brandName} Logo`}
          onError={() => setImageError(true)}
          className="h-9 w-auto max-w-[110px] sm:max-w-[160px] lg:max-w-[160px] object-contain"
        />
        {showSlogan && slogan && (
          <span className="hidden text-xs text-[var(--secondary)] 2xl:inline-block border-l border-[var(--border)] pl-3">
            {slogan}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={cn('flex min-w-0 items-center gap-2.5 select-none', className)}>
      <div className="flex h-9 w-9 items-center justify-center rounded-[var(--radius)] bg-[var(--primary)] text-[var(--on-primary)] shadow-sm shrink-0">
        <Shield className="h-5 w-5" />
      </div>
      <div className="flex flex-col text-left">
        <span className="font-display text-lg font-bold leading-tight tracking-tight text-[var(--foreground)] truncate min-w-0 max-w-[110px] sm:max-w-[160px] lg:max-w-[220px]">
          {shortName}
        </span>
        {showSlogan && slogan ? (
          <span className="text-xs text-[var(--secondary)] leading-tight truncate max-w-[220px]">
            {slogan}
          </span>
        ) : (
          <span className="text-xs font-semibold uppercase tracking-wider text-[var(--primary)]">
            Partner-Shop
          </span>
        )}
      </div>
    </div>
  );
}
